import { createFileRoute } from '@tanstack/react-router';

import Chart3D from '@/components/Chart3D';
import { ConfigureChartButton } from '@/components/ConfigureChartButton';
import { DownloadButton } from '@/components/DownloadButton';
import { RangeFilterButton } from '@/components/RangeFilterButton';
import { useChartTitle } from '@/contexts/ChartContext';
import { preflopEquityData } from '@/data/preflopEquityData';
import { usePageActions } from '@/hooks/usePageActions';
import { buildChartHeadMeta } from '@/lib/headMeta';

export const Route = createFileRoute('/preflop-equity')({
  component: PreflopEquity,
  head: () => buildChartHeadMeta({ chartData: preflopEquityData, ogImagePath: '/og/preflop-equity.png' }),
});

function PreflopEquity() {
  useChartTitle(preflopEquityData);
  usePageActions({
    secondary: () => (
      <>
        <RangeFilterButton />
        <DownloadButton />
      </>
    ),
    primary: () => <ConfigureChartButton />,
  });

  return <Chart3D data={preflopEquityData} />;
}
